var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('lottie-player',{staticStyle:{"width":"60px","height":"60px"},attrs:{"src":"https://assets5.lottiefiles.com/packages/lf20_tJIvme.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('span',[_vm._v("We're fetching real-time transfer fees and exchange rates....")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e164a00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 163
// module chunks = 0